import { graphql } from '@/lib/query'
const SectionFullWidthContentFragment = graphql(/* GraphQL */ `
  fragment SectionFullWidthContentFragment on SectionFullWidthContentRecord
  @_unmask {
    __typename
    _modelApiKey
    title
    content
  }
`)

export default SectionFullWidthContentFragment
